import { render, staticRenderFns } from "./ClassroomListFilter.vue?vue&type=template&id=2b2e740f"
import script from "./ClassroomListFilter.vue?vue&type=script&lang=js"
export * from "./ClassroomListFilter.vue?vue&type=script&lang=js"
import style0 from "./ClassroomListFilter.vue?vue&type=style&index=0&id=2b2e740f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports